'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.storyboardKeyHandlerWidget = function (storyboardController, storyboardModel, mapModel, addSceneHotkey) {
	return mmWidgets.each(this, function () {
		const element = this,
			addSceneHandler = function (evt) {
				const unicode = evt.charCode || evt.keyCode,
					actualkey = String.fromCharCode(unicode);
				if (actualkey === addSceneHotkey && mapModel.getInputEnabled()) {
					mapModel.applyToActivated(function (nodeId) {
						storyboardController.addScene(nodeId);
					});
				}
			};
		storyboardModel.addEventListener('inputEnabled', function (isEnabled) {
			if (isEnabled) {
				element.addEventListener('keypress', addSceneHandler);
			} else {
				element.removeEventListener('keypress', addSceneHandler);
			}
		});

	});
};
